import { React } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RadioGroupField, Radio, Flex, TextField, TextAreaField } from '@aws-amplify/ui-react';
import { typedReturnValue } from '../anamnese_lib/validateInteger';

const Allgemeines = (props) => {
    const daten = useSelector(state => state.anamnese.Daten);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        // console.log(e.target)
        const key = e.target.name;
        const val = typedReturnValue(key, e.target.value);
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    return (
        <>
            <h3>3 Allgemeines</h3>
            <TextAreaField
                name="ALLGEMEINES_TXT"
                width="100%"
                defaultValue={daten.ALLGEMEINES_TXT}
                onChange={handleChange}
                descriptiveText={<b>Möchten Sie uns noch etwas mitteilen?</b>}
                wrap="nowrap"
                maxLength={1024}
                rows={2}
                readOnly={props.readOnly}
            />
            <p></p>
            <h5>Haben Sie den Bogen selbst ausgefüllt?</h5>
            <Flex
                direction="row"
                alignItems="center"
            >
                <RadioGroupField
                    value={daten.SELBSTAUS}
                    onChange={handleChange}
                    descriptiveText=""
                    name="SELBSTAUS"
                    direction="row">
                    {['ja', 'nein,'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.SELBSTAUS !== i ? props.readOnly : false}>{item}</Radio>)}
                </RadioGroupField>
                {daten.SELBSTAUS === 1 &&
                    <TextField
                        label="mit Unterstützung von:"
                        name="SELBSTAUS_TXT"
                        defaultValue={daten.SELBSTAUS_TXT}
                        width="80%"
                        maxLength={80}
                        onChange={handleChange}
                        direction="row"
                        alignItems="center"
                        readOnly={props.readOnly}
                        />
                }
            </Flex>
        </>
    )
}

export default Allgemeines;